<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog()"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">担当者設定</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-form v-model="valid" ref="form">
					<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord
								:columnName="'分類'"
								:value="`[${category.keyword}] ${category.name}`"
								:tdStyle="{ backgroundColor: 'white' }"
							/>
							<ShowDetailRecord :columnName="'担当者'">
								<template v-slot:value>
									<v-select
										:items="users"
										v-model="user_id"
										item-text="full_name"
										item-value="id"
										hide-details
										dense
										outlined
										background-color="white"
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-form>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-col sm="3" cols="0" />
					<v-col class="text-center" sm="6" cols="12">
						<v-btn
							color="secondary"
							:disabled="!valid"
							@click="
								productCategoryUser ? updateProductCategoryUser() : createProductCategoryUser()
							"
						>
							<v-icon class="mr-1">mdi-content-save-outline</v-icon>
							保存する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" v-if="!$vuetify.breakpoint.xs" class="text-right">
						<v-btn class="ml-auto" text @click="closeDialog()"> キャンセル </v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import dialogMixin from "../../../helper/dialogMixin"

export default {
	props: {
		category: {
			type: Object,
			default: () => {},
		},
		productCategoryUser: {
			type: Object,
			default: () => {},
		},
		users: {
			type: Array,
			default: () => [],
		},
	},
	mixins: [dialogMixin("withoutBtn")],
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			user_id: null,
			valid: false,
			rules,
		}
	},
	methods: {
		updateProductCategoryUser() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/quality_assurances/product_category_users/${this.productCategoryUser.id}`
			const params = {
				product_category_user: {
					user_id: this.user_id,
					product_category_id: this.category.id,
				},
			}
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$emit("update-product-category-user", res.data)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `${this.category.name}の担当者を変更しました。`,
					})

					this.closeDialog()
					this.$refs.form.reset()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createProductCategoryUser() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/quality_assurances/product_category_users`
			const params = {
				product_category_user: {
					user_id: this.user_id,
					product_category_id: this.category.id,
				},
			}
			axios
				.post(url, params, { headers })
				.then((res) => {
					this.$emit("create-product-category-user", res.data)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `${this.category.name}の担当者を設定しました。`,
					})
					this.closeDialog()
					this.$refs.form.reset()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		productCategoryUser(val) {
			this.user_id = val ? val.user_id : null
			this.productCategoryUser = val
		},
	},
}
</script>